import { Link } from "react-router-dom";

interface PersonalizeSectionProps {
  onChangeCover: () => void;
  onChangeAvatar: () => void;
  canBecomeSeller?: boolean;
}

const rowClass =
  "flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-3.5 transition-colors hover:bg-background-100";

const actionClass =
  "inline-flex cursor-pointer items-center whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-semibold text-foreground-700";

/**
 * Sección compacta de configuración del perfil. No muestra las imágenes
 * (eso vive en el encabezado), solo acciones para editarlas y enlaces a
 * los ajustes de información, ubicación, seguridad e idioma.
 */
export default function PersonalizeSection({
  onChangeCover,
  onChangeAvatar,
  canBecomeSeller = false,
}: PersonalizeSectionProps) {
  return (
    <section className="rounded-lg border border-background-200/70 bg-background-50 p-5">
      <h2 className="font-heading text-lg font-bold text-foreground-950">
        Personaliza tu perfil
      </h2>
      <p className="mt-1 text-sm text-foreground-600">
        Ajustá cómo se ve tu perfil. Las imágenes se editan desde el encabezado.
      </p>

      <div className="mt-5 space-y-2">
        {canBecomeSeller && (
          <Link
            to="/perfil/solicitud-vendedor"
            className="flex items-center gap-3 rounded-lg border border-primary-200 bg-primary-100/60 p-3.5 transition-colors hover:bg-primary-100"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-white">
              <i className="ri-store-2-line text-xl"></i>
            </span>
            <span className="flex-1">
              <span className="block text-sm font-semibold text-foreground-900">
                Conviértete en vendedor
              </span>
              <span className="block text-xs text-foreground-500">
                Publica tus artículos y llega a miles de compradores
              </span>
            </span>
            <span className="inline-flex cursor-pointer items-center whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-semibold text-white">
              Registrarme
            </span>
          </Link>
        )}

        <button
          type="button"
          onClick={onChangeCover}
          className={`${rowClass} w-full cursor-pointer`}
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-foreground-500">
            <i className="ri-image-line text-xl"></i>
          </span>
          <span className="flex-1 text-left">
            <span className="block text-sm font-semibold text-foreground-900">
              Foto de portada
            </span>
            <span className="block text-xs text-foreground-500">
              Cambia la imagen que aparece arriba
            </span>
          </span>
          <span className={actionClass}>Cambiar</span>
        </button>

        <button
          type="button"
          onClick={onChangeAvatar}
          className={`${rowClass} w-full cursor-pointer`}
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-foreground-500">
            <i className="ri-user-line text-xl"></i>
          </span>
          <span className="flex-1 text-left">
            <span className="block text-sm font-semibold text-foreground-900">
              Foto de perfil
            </span>
            <span className="block text-xs text-foreground-500">
              Cambia tu foto principal
            </span>
          </span>
          <span className={actionClass}>Cambiar</span>
        </button>

        <Link to="/perfil/configuracion" className={rowClass}>
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-foreground-500">
            <i className="ri-edit-line text-xl"></i>
          </span>
          <span className="flex-1">
            <span className="block text-sm font-semibold text-foreground-900">
              Información
            </span>
            <span className="block text-xs text-foreground-500">
              Nombre, descripción y username
            </span>
          </span>
          <span className={actionClass}>Editar</span>
        </Link>

        <Link to="/perfil/configuracion" className={rowClass}>
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-foreground-500">
            <i className="ri-map-pin-line text-xl"></i>
          </span>
          <span className="flex-1">
            <span className="block text-sm font-semibold text-foreground-900">
              Ubicación
            </span>
            <span className="block text-xs text-foreground-500">
              Configura tu ubicación
            </span>
          </span>
          <span className={actionClass}>Editar</span>
        </Link>

        <Link to="/perfil/configuracion" className={rowClass}>
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-foreground-500">
            <i className="ri-lock-line text-xl"></i>
          </span>
          <span className="flex-1">
            <span className="block text-sm font-semibold text-foreground-900">
              Seguridad
            </span>
            <span className="block text-xs text-foreground-500">
              Contraseña y seguridad
            </span>
          </span>
          <span className={actionClass}>Administrar</span>
        </Link>

        <Link to="/perfil/configuracion" className={rowClass}>
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-foreground-500">
            <i className="ri-global-line text-xl"></i>
          </span>
          <span className="flex-1">
            <span className="block text-sm font-semibold text-foreground-900">
              Idioma
            </span>
            <span className="block text-xs text-foreground-500">
              Español / English
            </span>
          </span>
          <span className={actionClass}>Cambiar</span>
        </Link>
      </div>
    </section>
  );
}